/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-03-05T12:35:52.090Z by lizhutang (lizhutang@spolo.org)

'use strict'

let cachedCompFactory = {}
const COMPFACTREG = 'compfact:reg'
function reg (name, fact) {
  cachedCompFactory[name] = fact
  wwjs.EE.emit(COMPFACTREG, name, fact)
}
function get (name) {
  return cachedCompFactory[name]
}

function getComponents (wwInst, name, url) {
  // 下列代码应该放在factory中。
  if (!window.webeditorReg) {
    window.webeditorReg = {}
    window.webeditorReg.reg = reg
    window.webeditorReg.get = get
  }
  if (!name) {
    return false
  }

  let domc = wwInst.editor.DomComponents
  if (domc.getType(name)) {
    return true
  }
  let cachedFact = cachedCompFactory[name]
  if (cachedFact) {
    return Promise.resolve(cachedFact).then(function (fact) {
      if (window.$.isFunction(fact)) {
        return fact(wwInst, name)
      }
    })
  }
  cachedFact = cachedCompFactory[name] = new Promise(function (resolve, reject) {
    wwjs.loadjs.load(url, {
      success: function () {
        if ($.isFunction(cachedCompFactory[name])) {
          resolve(cachedCompFactory[name](wwInst, name))
        } else {
          let onFactReg = (regName, regFact) => {
            if (regName === name) {
              wwjs.EE.off(COMPFACTREG, onFactReg)
              resolve(regFact(wwInst, regName))
            }
          }
          wwjs.EE.on(COMPFACTREG, onFactReg)
        }
      },
      error: function (pathsNotFound) {
        reject(pathsNotFound)
      }
    })
  })
  return cachedFact
}

export default {
  get: getComponents
}
